/**
 * Corporate Theme - Main Entry Point
 * Focused on high-performance Vanilla JS and GSAP animations.
 */

// 1. Global Styles
import "../scss/style.scss";

// 2. Image Optimization (Lazysizes)
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// 3. Animation Engine
import { initScrollAnimations } from "./common/animation/scrollAnimations";

// 4. Prefetching
import { listen } from "quicklink";

/* // 6. Header & Navigation (Consolidated)
import { initHeader } from "./parts/header/header";
import { initMobileMenuOffcanvas } from "./parts/header/mobileMenu"; */
import { initLanguageSwitcher } from "./parts/header/languageSwitcher";

// 7. Page Content Components
import { initArchiveMasonry } from "./partials/PageContent/archiveMasonry";
import { initHeroSlider } from "./partials/PageContent/heroSlider";
import { initHeroBento } from "./partials/PageContent/heroBento";
import { initCtaSlider } from "./partials/PageContent/ctaSlider";
import { initCtaImageParallax } from "./partials/PageContent/ctaImage";
import { initArchiveShowcaseVideos } from "./partials/PageContent/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/articleWSlider";
import { initProductGallery } from "./templates/product/productGallery";

// 8. Post/CPT Content Components
import { initVideoFacades } from "./partials/PostContent/video";
import { initGalleries } from "./partials/PostContent/gallery";
import { initAccordions } from "./partials/PostContent/accordion";

// 9. Contact Form
import { initContactForm } from "./templates/contact/contactForm";

/**
 * Initialize all global and component-specific logic.
 * Internal guard clauses in each function prevent errors if
 * the target elements are missing from the current page.
 */
const initGlobals = () => {
  // Initialize Scroll-Triggered Animations (GSAP)
  initScrollAnimations();

  /*   /// Parts Initializers
  initHeader();
  initMobileMenuOffcanvas(); */
  initLanguageSwitcher();

  // --- Page Section Initializers ---
  initArchiveMasonry();
  initHeroSlider();
  initHeroBento();
  initCtaSlider();
  initCtaImageParallax();
  initArchiveShowcaseVideos();
  initArticleWSlider();
  initProductGallery();

  // --- Single Post/Service/Project Content Initializers ---
  initVideoFacades();
  initGalleries();
  initAccordions();

  // --- Contact Form Initializer ---
  initContactForm();

  // Start listening for in-viewport links to prefetch
  listen();

  console.log("[Main JS] Corporate Base initialized.");
};

// --- Bootstrap ---
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
